import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { instagramGallery } from "../data/siteData";
import { useZeoContent } from "../lib/ZeoContentContext";
import { optimizeImg } from "../lib/img";

export default function InstagramGallery() {
  const { business } = useZeoContent();
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="instagram-section">
      <div className="frida-container">
        <div className="text-center mb-12 lg:mb-14">
          <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
            · Instagram ·
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1]" data-testid="instagram-title">
            <span className="italic text-[#A85C34]">{business.social.instagramHandle}</span>
          </h2>
          <p className="mt-5 text-[#555555] text-lg">
            En yeni aranjmanlarımızı ve tasarım sürecimizi takip edin.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {instagramGallery.map((img, i) => (
            <motion.a
              key={i}
              href={business.social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative aspect-square overflow-hidden rounded-2xl bg-[#F8F8F8] block"
              data-testid={`instagram-item-${i}`}
            >
              <img
                src={optimizeImg(img, 350)}
                alt={`Instagram ${i + 1}`}
                width="350"
                height="350"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#A85C34]/0 group-hover:bg-[#A85C34]/70 transition-colors duration-300 flex items-center justify-center">
                <Instagram className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </motion.a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={business.social.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-[#222222] text-[#222222] hover:bg-[#222222] hover:text-white rounded-full font-medium transition-all"
            data-testid="instagram-follow-button"
          >
            <Instagram className="w-4 h-4" />
            Instagram&apos;da Takip Et
          </a>
        </div>
      </div>
    </section>
  );
}
